import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import localforage from 'localforage';
import CampManagementForm from './CampManagementForm';
import { AlignCenter } from 'lucide-react';

const BASE_URL = 'https://lager-app-api.sunrise-avengers.ch:443';

const CampList = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth <= 768;
  const [overlayVisible, setOverlayVisible] = useState(false);

  const [camps, setCamps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedCamp, setSelectedCamp] = useState(null);
  const [expandedCampId, setExpandedCampId] = useState(null);
  const [expandedSection, setExpandedSection] = useState(null);
  const [filter, setFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'startDate', direction: 'asc' });
  const [visiblePastCamps, setVisiblePastCamps] = useState(false);
  const styles = {
    container: {
      padding: '32px',
      maxWidth: 'auto',
      margin: '0 auto',
      backgroundColor: '#f8fafc',
      minHeight: '100vh',
      marginLeft: isMobile ? "-20px" : 'auto',
      alignItems:"center",
      borderRadius:"20px",
      width: isMobile ? "93%" : 'auto',
      marginTop:isMobile ? "0px" : 'auto',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '32px',
      
      Width: isMobile ? "20px" : 'auto',
    },
    headerLeft: {
      flex: 1,
      // marginRight: '32px',
      marginLeft: isMobile ? "32px" : 'auto',
      marginTop: isMobile ? "-126px" : "0", // Abstand nach oben bei Mobile
      Width: isMobile ? "200px" : 'auto',



    },
    title: {
      fontSize: '32px',
      fontWeight: '600',
      color: '#1e293b',
      margin: '0 0 16px 0',
      textAlign:"center"

    },
    controls: {
      display: 'flex',
      gap: '16px',
      marginLeft: isMobile ? "auto" : 'auto',
      alignItems: "center",
      flexDirection: isMobile ? "column" : "row", // Vertikal für Mobile
    },
    searchInput: {
      padding: '10px 16px',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
      fontSize: '14px',
      outline: 'none',
      width: isMobile ? "255px" : '70%',
      
      
    },
    filterSelect: {
      padding: '10px 16px',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
      fontSize: '14px',
      color: '#475569',
      backgroundColor: '#ffffff',
      cursor: 'pointer',
      outline: 'none',
      marginLeft: isMobile ? "-7px" : '-0%',

      width: isMobile ? "255px" : 'auto',
    },
    addButton: {
      padding: '12px 24px',
      backgroundColor: '#3b82f6',
      color: '#ffffff',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      fontWeight: '500',
      fontSize: '14px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      marginTop: isMobile ? "236px" : "55px", // Abstand nach oben bei Mobile
      width: isMobile ? "100%" : "auto", // Volle Breite bei Mobile
      marginLeft: isMobile ? "-300px" : 'auto',

    },
   
    campGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))',
      gap: '32px',
      marginTop: '24px',
      
      marginLeft: isMobile ? "-7px" : 'auto',
      
      

      
    },
    campCard: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      padding: '24px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
      border: '1px solid #e2e8f0',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      cursor: 'pointer',
      position: 'relative', // Add this
      // width: isMobile ? "305px" : 'auto',
      width: isMobile ? "255px" : 'auto',

    },
    pastCampsToggle: {
      marginTop: '24px',
      padding: '12px 24px',
      backgroundColor: '#f1f5f9',
      borderRadius: '8px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginLeft: isMobile ? "-17px" : 'auto',
      width: isMobile ? "100%" : "auto", // Volle Breite bei Mobile

    },
  
    expandedContent: {
      position: 'absolute', // Change to absolute
      left: 0,
      right: 0,
      top: '100%', // Position it below the card
      backgroundColor: '#ffffff',
      borderRadius: '0 0 12px 12px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      zIndex: 10,
      marginTop: '1px',
      padding: '16px',
      border: '1px solid #e2e8f0',
      borderTop: 'none',
    },
  
    // Add new overlay style
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.1)',
      zIndex: 5,
      display: 'none',
    },
  
    campHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '16px',
    },
    campTitle: {
      margin: 0,
      fontSize: '20px',
      fontWeight: '600',
      color: '#1e293b',
    },
    statusBadge: {
      padding: '4px 12px',
      borderRadius: '9999px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#ffffff',
    },
    campDates: {
      marginBottom: '16px',
      fontSize: '14px',
      color: '#64748b',
      lineHeight: '1.5',
    },
    description: {
      fontSize: '14px',
      color: '#64748b',
      lineHeight: '1.6',
      marginBottom: '16px',
    },
    expandedContent: {
      marginTop: '16px',
      borderTop: '1px solid #e2e8f0',
      paddingTop: '16px',
      overflow: 'hidden',
    },
    overlayActive: {
      display: 'block',},
    sections: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    section: {
      borderBottom: '1px solid #e2e8f0',
      paddingBottom: '16px',
    },
    sectionHeader: {
      margin: 0,
      padding: '12px',
      backgroundColor: '#f8fafc',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderRadius: '6px',
      fontSize: '16px',
      fontWeight: '500',
      color: '#1e293b',
    },
    sectionIcon: {
      fontSize: '12px',
      color: '#64748b',
    },
    scheduleList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      marginTop: '16px',
    },
    scheduleItem: {
      padding: '16px',
      backgroundColor: '#f8fafc',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
    },
    scheduleTime: {
      marginBottom: '8px',
      color: '#64748b',
      fontSize: '14px',
    },
    scheduleContent: {
      color: '#1e293b',
    },
    scheduleTitle: {
      margin: '0 0 4px 0',
      color: '#1e293b',
      fontSize: '16px',
      fontWeight: '500',
    },
    scheduleLocation: {
      color: '#64748b',
      fontSize: '14px',
      margin: '4px 0',
    },
    scheduleDescription: {
      color: '#64748b',
      fontSize: '14px',
      margin: '4px 0',
      lineHeight: '1.5',
    },
    phaseContent: {
      padding: '16px',
    },
    phaseDates: {
      color: '#64748b',
      marginBottom: '16px',
      fontSize: '14px',
    },
    packingList: {
      marginTop: '16px',
    },
    packingListTitle: {
      fontSize: '16px',
      marginBottom: '8px',
      color: '#1e293b',
      fontWeight: '500',
    },
    packingItem: {
      padding: '4px 0',
      color: '#64748b',
      fontSize: '14px',
    },
    activityList: {
      marginTop: '16px',
    },
    activityListTitle: {
      fontSize: '16px',
      marginBottom: '8px',
      color: '#1e293b',
      fontWeight: '500',
    },
    activityItem: {
      padding: '4px 0',
      color: '#64748b',
      fontSize: '14px',
    },
    cardActions: {
      display: 'flex',
      gap: '8px',
      marginTop: '16px',
    },
    detailsButton: {
      flex: 1,
      padding: '10px',
      backgroundColor: '#f8fafc',
      color: '#1e293b',
      border: '1px solid #e2e8f0',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '500',
    },
    editButton: {
      flex: 1,
      padding: '10px',
      backgroundColor: '#3b82f6',
      color: '#ffffff',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '500',
    },
    deleteButton: {
      flex: 1,
      padding: '10px',
      backgroundColor: '#ef4444',
      color: '#ffffff',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '500',
    },
    modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    modalContent: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      width: '90%',
      maxWidth: '800px',
      maxHeight: '90vh',
      overflow: 'auto',
      padding: '24px',
    },
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '64px',
      color: '#64748b',
      fontSize: '16px',
      gap: '16px',
    },
    loadingSpinner: {
      border: '4px solid #f3f3f3',
      borderTop: '4px solid #3b82f6',
      borderRadius: '50%',
      width: '40px',
      height: '40px',
      animation: 'spin 1s linear infinite',
    },
    errorContainer: {
      padding: '24px',
      backgroundColor: '#fee2e2',
      borderRadius: '8px',
      margin: '24px',
    },
    errorText: {
      color: '#dc2626',
      textAlign: 'center',
      fontSize: '16px',
    },
    emptyState: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '64px',
      textAlign: 'center',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      border: '2px dashed #e2e8f0',
    },
    emptyStateIcon: {
      fontSize: '48px',
      marginBottom: '16px',
    }, pastCampsSection: {
      marginTop: '24px',
      padding: '16px',
      backgroundColor: '#f8fafc',
      borderRadius: '12px',
      cursor: 'pointer',
      width: isMobile ? "105%" : 'auto',
      marginLeft: isMobile ? "-17px" : 'auto',
    },
    pastCampsHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px',
      backgroundColor: '#f1f5f9',
      borderRadius: '8px',
      marginBottom: '16px',
      marginLeft: isMobile ? "-1px" : 'auto',
      width: isMobile ? "90%" : "auto", // Volle Breite bei Mobile
    },
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    fetchCamps();
  }, [filter]);

// Updated fetchCamps function for CampList.js
const fetchCamps = async () => {
  setLoading(true);
  setError(null);
  try {
    const token = await localforage.getItem('token');
    if (!token) {
      throw new Error('Not logged in - please login again');
    }

    // First try the alternate endpoint which might handle the data differently
    console.log('Trying camps/all endpoint...');
    let response = await fetch(`${BASE_URL}/api/camps/all`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    // If that endpoint also fails, show a more descriptive error
    if (!response.ok) {
      console.error('Error details:', await response.text());
      throw new Error('Unable to load camps. The server returned an error.');
    }

    const data = await response.json();
    setCamps(data);
  } catch (err) {
    console.error('Fetch error:', err);
    setError(err.message);
  } finally {
    setLoading(false);
  }
};

  const deleteCamp = async (campId) => {
    try {
      const token = await localforage.getItem('token');
      if (!token) {
        throw new Error('Not logged in - please login again');
      }
    
      const response = await fetch(`${BASE_URL}/api/camps/${campId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
    
      if (!response.ok) {
        throw new Error('Error deleting camp');
      }
    
      fetchCamps();
    } catch (err) {
      setError(err.message);
    }
  };

  const getStatus = (startDate, endDate) => {
    const now = new Date();
    const start = new Date(startDate);
    const end = new Date(endDate);

    if (now < start) {
      return { text: 'Upcoming', color: '#f59e0b' };
    } else if (now > end) {
      return { text: 'Past', color: '#64748b' };
    }
    return { text: 'Active', color: '#10b981' };
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('de-DE', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const toggleCampExpansion = (campId) => {
    if (expandedCampId === campId) {
      setExpandedCampId(null);
      setExpandedSection(null);
      setOverlayVisible(false);
    } else {
      setExpandedCampId(campId);
      setExpandedSection(null);
      setOverlayVisible(true);
    }
  };
 const splitCamps = camps.reduce((acc, camp) => {
    const status = getStatus(camp.startDate, camp.endDate);
    if (status.text === 'Past') {
      acc.past.push(camp);
    } else {
      acc.current.push(camp);
    }
    return acc;
  }, { current: [], past: [] });
  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const handleSort = (key) => {
    setSortConfig({
      key,
      direction: sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc'
    });
  };

  const filteredCamps = camps
    .filter(camp => camp.title.toLowerCase().includes(searchQuery.toLowerCase()))
    .sort((a, b) => {
      const direction = sortConfig.direction === 'asc' ? 1 : -1;
      if (sortConfig.key === 'status') {
        const statusA = getStatus(a.startDate, a.endDate).text;
        const statusB = getStatus(b.startDate, b.endDate).text;
        return direction * statusA.localeCompare(statusB);
      }
      return direction * (new Date(a[sortConfig.key]) - new Date(b[sortConfig.key]));
    });

  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.loadingSpinner}></div>
        <span>Loading...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.errorContainer}>
        <p style={styles.errorText}>Error: {error}</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <h1 style={styles.title}>Camp Management</h1>
          <div style={styles.controls}>
            <input
              type="text"
              placeholder="Search camps..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={styles.searchInput}
            />
            <select
              onChange={(e) => handleSort(e.target.value)}
              value={sortConfig.key}
              style={styles.filterSelect}
            >
              <option value="startDate">Sort by Start Date</option>
              <option value="endDate">Sort by End Date</option>
              <option value="status">Sort by Status</option>
            </select>
          </div>
        </div>
        <motion.button
          onClick={() => {
            setSelectedCamp(null);
            setShowForm(true);
          }}
          style={styles.addButton}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          + New Camp
        </motion.button>
        <div 
          style={{
            ...styles.overlay,
            ...(overlayVisible ? styles.overlayActive : {})
          }}
          onClick={() => {
            setExpandedCampId(null);
            setExpandedSection(null);
            setOverlayVisible(false);
          }}
        />
      </div>
  
      {splitCamps.current.length === 0 && splitCamps.past.length === 0 ? (
        <div style={styles.emptyState}>
          <div style={styles.emptyStateIcon}>🏕️</div>
          <h3>No camps found</h3>
          <p>Create a new camp or adjust your filter settings.</p>
        </div>
      ) : (
        <>
          <div style={styles.campGrid}>
            <AnimatePresence>
              {splitCamps.current.map(camp => {
                const status = getStatus(camp.startDate, camp.endDate);
                
                return (
                  <motion.div
                    key={camp.id}
                    style={{
                      ...styles.campCard,
                      zIndex: expandedCampId === camp.id ? 20 : 1,
                    }}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    layout="position"
                    onClick={() => toggleCampExpansion(camp.id)}
                    whileHover={{ 
                      scale: 1.02,
                      boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
                      transition: { duration: 0.3 }
                    }}
                    transition={{ type: "spring", stiffness: 300 }}
                  >
                    <div style={styles.campHeader}>
                      <h3 style={styles.campTitle}>{camp.title}</h3>
                      <span style={{
                        ...styles.statusBadge,
                        backgroundColor: status.color
                      }}>
                        {status.text}
                      </span>
                    </div>
  
                    <div style={styles.campDates}>
                      <div><strong>Start:</strong> {formatDate(camp.startDate)}</div>
                      <div><strong>End:</strong> {formatDate(camp.endDate)}</div>
                    </div>
  
                    {camp.description && (
                      <div style={styles.description}>
                        {camp.description.substring(0, 100)}
                        {camp.description.length > 100 ? '...' : ''}
                      </div>
                    )}
  
                    {expandedCampId === camp.id && (
                      <motion.div 
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        style={styles.expandedContent}
                        onClick={e => e.stopPropagation()}
                      >
                        <div style={styles.sections}>
                          <div style={styles.section}>
                            <h4 
                              style={styles.sectionHeader}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleSection('schedule');
                              }}
                            >
                              Schedule ({camp.schedule?.length || 0} items)
                              <span style={styles.sectionIcon}>
                                {expandedSection === 'schedule' ? '▼' : '▶'}
                              </span>
                            </h4>
                            
                            {expandedSection === 'schedule' && camp.schedule && (
                              <div style={styles.scheduleList}>
                                {camp.schedule.map((item, index) => (
                                  <div key={index} style={styles.scheduleItem}>
                                    <div style={styles.scheduleTime}>
                                      <strong>{formatDate(item.date)}</strong>
                                      {item.startTime && <span> {item.startTime}</span>}
                                      {item.endTime && <span> - {item.endTime}</span>}
                                    </div>
                                    <div style={styles.scheduleContent}>
                                      <h5 style={styles.scheduleTitle}>{item.title}</h5>
                                      {item.location && 
                                        <p style={styles.scheduleLocation}>{item.location}</p>}
                                      {item.description && 
                                        <p style={styles.scheduleDescription}>{item.description}</p>}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
  
                          {camp.phases?.map((phase) => (
                            <div key={phase.id} style={styles.section}>
                              <h4 
                                style={styles.sectionHeader}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleSection(`phase-${phase.id}`);
                                }}
                              >
                                {phase.phaseType === 'PRE_CAMP' ? 'Pre-Camp' :
                                 phase.phaseType === 'MAIN_CAMP' ? 'Main Camp' : 'Post-Camp'}
                                <span style={styles.sectionIcon}>
                                  {expandedSection === `phase-${phase.id}` ? '▼' : '▶'}
                                </span>
                              </h4>
  
                              {expandedSection === `phase-${phase.id}` && (
                                <div style={styles.phaseContent}>
                                  <div style={styles.phaseDates}>
                                    {formatDate(phase.startDate)} - {formatDate(phase.endDate)}
                                  </div>
                                  
                                  {phase.packingItems?.length > 0 && (
                                    <div style={styles.packingList}>
                                      <h5 style={styles.packingListTitle}>Packing List:</h5>
                                      {phase.packingItems.map((item, index) => (
                                        <div key={index} style={styles.packingItem}>
                                          • {item.item}
                                        </div>
                                      ))}
                                    </div>
                                  )}
  
                                  {phase.activityItems?.length > 0 && (
                                    <div style={styles.activityList}>
                                      <h5 style={styles.activityListTitle}>Activities:</h5>
                                      {phase.activityItems.map((item, index) => (
                                        <div key={index} style={styles.activityItem}>
                                          • {item.activity}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                        <div style={styles.cardActions} onClick={(e) => e.stopPropagation()}>
                          <motion.button
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedCamp(camp);
                              setShowForm(true);
                            }}
                            style={styles.editButton}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                          >
                            Edit
                          </motion.button>
                          <motion.button
                            onClick={(e) => {
                              e.stopPropagation();
                              if (window.confirm('Are you sure you want to delete this camp?')) {
                                deleteCamp(camp.id);
                              }
                            }}
                            style={styles.deleteButton}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                          >
                            Delete
                          </motion.button>
                        </div>
                      </motion.div>
                    )}
  
                    <div style={styles.cardActions} onClick={(e) => e.stopPropagation()}>
                      <motion.button
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleCampExpansion(camp.id);
                        }}
                        style={styles.detailsButton}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                      >
                        {expandedCampId === camp.id ? 'Hide Details' : 'Show Details'}
                      </motion.button>
                    </div>
                  </motion.div>
                );
              })}
            </AnimatePresence>
          </div>
  
          {splitCamps.past.length > 0 && (
            <motion.div
              style={styles.pastCampsSection}
              initial={false}
            >
              <div 
                style={styles.pastCampsHeader}
                onClick={() => setVisiblePastCamps(!visiblePastCamps)}
              >
                <h3>Past Camps ({splitCamps.past.length})</h3>
                <motion.span
                  animate={{ rotate: visiblePastCamps ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                  
                >
                  ▼
                </motion.span>
              </div>
  
              <AnimatePresence>
                {visiblePastCamps && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: 'auto' }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.5 }}
                    style={styles.campGrid}
                  >
                    {splitCamps.past.map(camp => {
                      const status = getStatus(camp.startDate, camp.endDate);
                      
                      return (
                        <motion.div
                          key={camp.id}
                          style={{
                            ...styles.campCard,
                            opacity: 0.8,
                            zIndex: expandedCampId === camp.id ? 20 : 1
                          }}
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 0.8, y: 0 }}
                          exit={{ opacity: 0, y: -20 }}
                          layout="position"
                          onClick={() => toggleCampExpansion(camp.id)}
                          whileHover={{ 
                            scale: 1.02,
                            opacity: 1,
                            boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
                            transition: { duration: 0.3 }
                          }}
                          transition={{ type: "spring", stiffness: 300 }}
                        >
                          {/* Same card content structure as current camps */}
                          <div style={styles.campHeader}>
                            <h3 style={styles.campTitle}>{camp.title}</h3>
                            <span style={{
                              ...styles.statusBadge,
                              backgroundColor: status.color
                            }}>
                              {status.text}
                            </span>
                          </div>
  
                          <div style={styles.campDates}>
                            <div><strong>Start:</strong> {formatDate(camp.startDate)}</div>
                            <div><strong>End:</strong> {formatDate(camp.endDate)}</div>
                          </div>
  
                          {camp.description && (
                            <div style={styles.description}>
                              {camp.description.substring(0, 100)}
                              {camp.description.length > 100 ? '...' : ''}
                            </div>
                          )}
   {expandedCampId === camp.id && (
                    <motion.div 
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      style={styles.expandedContent}
                      onClick={e => e.stopPropagation()}
                    >
                      <div style={styles.sections}>
                        <div style={styles.section}>
                          <h4 
                            style={styles.sectionHeader}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleSection('schedule');
                            }}
                          >
                            Schedule ({camp.schedule?.length || 0} items)
                            <span style={styles.sectionIcon}>
                              {expandedSection === 'schedule' ? '▼' : '▶'}
                            </span>
                          </h4>
                          
                          {expandedSection === 'schedule' && camp.schedule && (
                            <div style={styles.scheduleList}>
                              {camp.schedule.map((item, index) => (
                                <div key={index} style={styles.scheduleItem}>
                                  <div style={styles.scheduleTime}>
                                    <strong>{formatDate(item.date)}</strong>
                                    {item.startTime && <span> {item.startTime}</span>}
                                    {item.endTime && <span> - {item.endTime}</span>}
                                  </div>
                                  <div style={styles.scheduleContent}>
                                    <h5 style={styles.scheduleTitle}>{item.title}</h5>
                                    {item.location && 
                                      <p style={styles.scheduleLocation}>{item.location}</p>}
                                    {item.description && 
                                      <p style={styles.scheduleDescription}>{item.description}</p>}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        {camp.phases?.map((phase) => (
                          <div key={phase.id} style={styles.section}>
                            <h4 
                              style={styles.sectionHeader}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleSection(`phase-${phase.id}`);
                              }}
                            >
                              {phase.phaseType === 'PRE_CAMP' ? 'Pre-Camp' :
                               phase.phaseType === 'MAIN_CAMP' ? 'Main Camp' : 'Post-Camp'}
                              <span style={styles.sectionIcon}>
                                {expandedSection === `phase-${phase.id}` ? '▼' : '▶'}
                              </span>
                            </h4>

                            {expandedSection === `phase-${phase.id}` && (
                              <div style={styles.phaseContent}>
                                <div style={styles.phaseDates}>
                                  {formatDate(phase.startDate)} - {formatDate(phase.endDate)}
                                </div>
                                
                                {phase.packingItems?.length > 0 && (
                                  <div style={styles.packingList}>
                                    <h5 style={styles.packingListTitle}>Packing List:</h5>
                                    {phase.packingItems.map((item, index) => (
                                      <div key={index} style={styles.packingItem}>
                                        • {item.item}
                                      </div>
                                    ))}
                                  </div>
                                )}

                                {phase.activityItems?.length > 0 && (
                                  <div style={styles.activityList}>
                                    <h5 style={styles.activityListTitle}>Activities:</h5>
                                    {phase.activityItems.map((item, index) => (
                                      <div key={index} style={styles.activityItem}>
                                        • {item.activity}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                      <div style={styles.cardActions} onClick={(e) => e.stopPropagation()}>
                        <motion.button
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedCamp(camp);
                            setShowForm(true);
                          }}
                          style={styles.editButton}
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                        >
                          Edit
                        </motion.button>
                        <motion.button
                          onClick={(e) => {
                            e.stopPropagation();
                            if (window.confirm('Are you sure you want to delete this camp?')) {
                              deleteCamp(camp.id);
                            }
                          }}
                          style={styles.deleteButton}
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                        >
                          Delete
                        </motion.button>
                      </div>
                    </motion.div>
                  )}
                          <div style={styles.cardActions} onClick={(e) => e.stopPropagation()}>
                            <motion.button
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleCampExpansion(camp.id);
                              }}
                              style={styles.detailsButton}
                              whileHover={{ scale: 1.05 }}
                              whileTap={{ scale: 0.95 }}
                            >
                              {expandedCampId === camp.id ? 'Hide Details' : 'Show Details'}
                            </motion.button>
                          </div>
                        </motion.div>
                      );
                    })}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          )}
        </>
      )}
  
      <AnimatePresence>
        {showForm && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={styles.modal}
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                setShowForm(false);
                setSelectedCamp(null);
              }
            }}
          >
            <div style={styles.modalContent}>
              <CampManagementForm
                initialData={selectedCamp}
                onClose={() => {
                  setShowForm(false);
                  setSelectedCamp(null);
                  fetchCamps();
                }}
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CampList;